import React, { useState } from 'react';
import './People.css';
import Header from './Header';

const peopleData = [
  {
    id: 1,
    name: 'Jane Doe',
    title: 'Software Engineer at XYZ Corp',
    location: 'San Francisco, CA',
    picture: 'https://via.placeholder.com/150',
    summary: 'Experienced developer specializing in React.js.',
    experience: ['Frontend Developer at ABC', 'Software Engineer at XYZ Corp'],
  },
  {
    id: 2,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 3,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 4,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 5,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 6,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 7,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  // Add more profiles as needed...
];

const initialAssociatedMembersData = [
  { id: 1, category: "Where they live", subcategory: "India", count: 18041 },
  { id: 2, category: "Where they live", subcategory: "Greater Delhi Area", count: 4340 },
  { id: 3, category: "Where they live", subcategory: "Delhi, India", count: 2586 },
  { id: 4, category: "Where they live", subcategory: "New Delhi", count: 2113 },
  { id: 5, category: "Where they studied", subcategory: "Delhi University", count: 332 },
  { id: 6, category: "Where they studied", subcategory: "Indira Gandhi National Open University", count: 103 },
  { id: 7, category: "Where they studied", subcategory: "Amity University", count: 101 },
  { id: 8, category: "Where they studied", subcategory: "Guru Gobind Singh Indraprastha University", count: 86 },
];

const handleConnect = (id) => {
  alert(`Connection request sent to profile ID: ${id}`);
  // Additional logic: Save this action to the backend or local state
};


const People = () => {
  // Move the useState call here
  const [associatedMembersData, setAssociatedMembersData] = useState(initialAssociatedMembersData);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [profilesToShow, setProfilesToShow] = useState(2); // Initial profiles to show

  const profilesPerPage = 2;
  const totalPages = Math.ceil(peopleData.length / profilesPerPage);

  const filteredProfiles = peopleData.filter((profile) =>
    profile.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAdd = (type) => {
    const newItem = prompt(`Add a new ${type}:`);
    if (newItem) {
      // Check if the item already exists in associatedMembersData
      const existingEntryIndex = associatedMembersData.findIndex(
        (entry) => entry.subcategory === newItem
      );
  
      if (existingEntryIndex !== -1) {
        // Increment the count of the existing entry
        const updatedData = [...associatedMembersData];
        updatedData[existingEntryIndex].count += 1;
        setAssociatedMembersData(updatedData);
      } else {
        // Create a new entry
        const newId = associatedMembersData.length + 1;
        const newEntry = {
          id: newId,
          category: type === 'place' ? 'Where they live' : 'Where they studied',
          subcategory: newItem,
          count: 1, // Default count for a new entry
        };
        setAssociatedMembersData([...associatedMembersData, newEntry]);
      }
    }
  };
  

  return (
    <>
    <Header/>
    <div className='container'>
      <div className="peoples-page">
       {/* Top Navigation */}
       <div className='container'>
        {/* Associated Members Section */}
        <div className="associated-members">
         <h1>16,752 Associated Members</h1>

       {/* Search Bar */}
          <div className="search-bar">
           <input
            type="text"
            placeholder="Search people..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}/>
          </div>

  <div className="associated-members-sections">
    <div className="associated-members-section">
      <h2>Where they live <button className="add-btn" onClick={() => handleAdd('place')}>
      + Add
        </button></h2>
      {associatedMembersData
        .filter((item) => item.category === "Where they live")
        .map((item) => (
          <div key={item.id} className="data-row">
            <p>{item.subcategory}</p>
            <div className="bar-container">
              <div
                className="bar"
                style={{ width: `${(item.count / 18041) * 100}%` }}
              ></div>
            </div>
            <p>{item.count}</p>
          </div>
        ))}
    </div>

    <div className="associated-members-section">
      <h2>Where they studied  <button className="add-btn" onClick={() => handleAdd('education')}>
      + Add
    </button></h2>
      {associatedMembersData
        .filter((item) => item.category === "Where they studied")
        .map((item) => (
          <div key={item.id} className="data-row">
            <p>{item.subcategory}</p>
            <div className="bar-container">
              <div
                className="bar"
                style={{ width: `${(item.count / 18041) * 100}%` }}
              ></div>
            </div>
            <p>{item.count}</p>
          </div>
        ))}
    </div>
  </div>
</div>
</div>
<br/>

        {/* Profiles List */}
        <div className='container'>
          <div className="peoples-list">
             {filteredProfiles.map((profile) => (
             <div
                key={profile.id}
                className="peoples-card"
                onClick={() => setSelectedProfile(profile)}>
                <img src={profile.picture} alt={`${profile.name}'s profile`} />
                <h3>{profile.name}</h3>
                <p>{profile.title}</p>
                <p>{profile.location}</p>
                <button onClick={() => handleConnect(profile.id)}>Connect</button>
              </div>
          ))}
          </div>

        {/* Profile Details Modal */}
        {selectedProfile && (
          <div className="peoples-details">
            <button className="close-btn" onClick={() => setSelectedProfile(null)}>
              Close
            </button>
            <img src={selectedProfile.picture} alt={`${selectedProfile.name}'s profile`} />
            <h2>{selectedProfile.name}</h2>
            <p>{selectedProfile.title}</p>
            <p>{selectedProfile.location}</p>
            <p>{selectedProfile.summary}</p>
            <h3>Experience</h3>
            <ul>
              {selectedProfile.experience.map((exp, idx) => (
                <li key={idx}>{exp}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
    </div>
    </>
  );
};

export default People;
